export const SET_YESBANK_ZINGER_CARDS_FAQ = 'yesBankZingerCard/SET_YESBANK_ZINGER_CARDS_FAQ';
export const DEFAULT_ACTION = '/YesBankFaQs/DEFAULT_ACTION';



// WEBPACK FOOTER //
// client/containers/YesBankFaQs/constants.js